import React from 'react';
import { IconProps } from './types';

export function EditIcon(props: IconProps) {
	const { width, height, stroke } = props;
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 16 16"
			fill="none"
		>
			<path
				d="M7.22184 1.17358H5.83921C2.38263 1.17358 1 2.55622 1 6.0128V10.1607C1 13.6173 2.38263 14.9999 5.83921 14.9999H9.98711C13.4437 14.9999 14.8263 13.6173 14.8263 10.1607V8.77806"
				stroke={stroke}
				strokeWidth="1.15"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M10.7061 1.87882L5.25857 7.32639C5.05117 7.53379 4.84378 7.94167 4.8023 8.23893L4.50503 10.3198C4.39442 11.0733 4.92673 11.5987 5.68027 11.495L7.76113 11.1978C8.05148 11.1563 8.45936 10.9489 8.67367 10.7415L14.1212 5.29392C15.0614 4.35373 15.5039 3.26145 14.1212 1.87882C12.7386 0.496189 11.6463 0.938631 10.7061 1.87882Z"
				stroke={stroke}
				strokeWidth="1.15"
				strokeMiterlimit="10"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M9.9248 2.65979C10.388 4.31204 11.6807 5.6048 13.3399 6.07489"
				stroke={stroke}
				strokeWidth="1.15"
				strokeMiterlimit="10"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
